import { Button, Grid, GridColumn, IButtonProps, INoticeProps, Notice, Text } from 'telia-front-react';
import React from 'react';

export interface NoticeWithButtonProps {
  text: string | React.ReactNode;
  buttonProps: IButtonProps;
  noticeProps?: Omit<INoticeProps, 'children'>;
}

export const NoticeWithButton = ({ text, buttonProps, noticeProps }: NoticeWithButtonProps) => {
  return (
    <Notice {...noticeProps}>
      <Grid align={['between-xs', 'middle-xs']} noWrap={['sm']}>
        <GridColumn width={['xs', 'max-sm']}>
          <Text>{text}</Text>
        </GridColumn>
        <GridColumn width={['xs', 'min-sm']}>
          <Button {...buttonProps} />
        </GridColumn>
      </Grid>
    </Notice>
  );
};

export default NoticeWithButton;
